import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable, Injector } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { APP_CONFIG, IAppConfig } from '@app/core/services/app.config';
import { EventsService } from '@app/core/services/events.service';
import { StorageService } from '@app/core/services/storage.service';
import { UserService } from '@app/core/services/user.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    @Inject(APP_CONFIG) private readonly appConfig: IAppConfig,
    public storageService: StorageService,
    private eventsService: EventsService,
    private injector: Injector,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (request.method === 'POST') {
      request = request.clone({
        setHeaders: {
          Authorization: `${this.storageService.TOKEN}`,
          Accept: `application/json`,
          Core: `${this.appConfig.settings.config_name}`,
        },
      });
    }
    if (
      request.method === 'GET' &&
      this.appConfig.settings.config_name &&
      !request.url.includes('bitbucket')
    ) {
      request = request.clone({
        setHeaders: {
          Core: `${this.appConfig.settings.config_name}`,
        },
      });
    }
    if (request.method === 'GET' && this.storageService.TOKEN) {
      request = request.clone({
        setHeaders: {
          Authorization: `${this.storageService.TOKEN}`,
        },
      });
    }
    return next.handle(request).pipe(
      catchError(e => {
        if (e.error) {
          console.log(e);
          if (e.error.reason === 'exception') {
            this.eventsService.errorHappensSource('server');
          } else if (
            e.error.reason === 'invalid_form' &&
            e.error.errors &&
            e.error.errors.length > 0
          ) {
            const { errors } = e.error;
            let errorMsg = '';
            // eslint-disable-next-line guard-for-in
            for (const err in errors) {
              errorMsg = `${errorMsg} ${errors[err][0]}`;
            }
            this.eventsService.errorHappensSource(errorMsg, false);
          } else if (e.error.message) {
            this.eventsService.errorHappensSource(e.error.message, false);
          }
        } else {
          this.eventsService.errorHappensSource('server');
        }
        switch (e.status) {
          case 500:
            this.eventsService.errorHappensSource('server');
            break;
          case 401:
            const auth = this.injector.get(UserService);
            auth.logout();
            this.eventsService.forceLogoutSource(e.error.error);
            this.eventsService.errorHappensSource(e.error.error);
            break;
        }
        return throwError(e);
      }),
    );
    // return next.handle(request).catch((e, caught) => {
    //   if (e.error) {
    //     if (e.error.reason === 'exception') {
    //       this.eventsService.errorHappensSource('server');
    //     } else if (e.error.reason === 'invalid_form' && e.error.errors && e.error.errors.length > 0) {
    //       const errors = e.error.errors;
    //       let errorMsg = '';
    //       // tslint:disable-next-line:forin
    //       for (const err in errors) {
    //         errorMsg = `${errorMsg} ${errors[err][0]}`;
    //       }
    //       this.eventsService.errorHappensSource(errorMsg, false);
    //     } else if (e.error.message) {
    //       this.eventsService.errorHappensSource(e.error.message, false);
    //     }
    //   } else {
    //     this.eventsService.errorHappensSource('server');
    //   }
    //   switch (e.status) {
    //     case 500:
    //       this.eventsService.errorHappensSource('server');
    //       break;
    //     case 401:
    //       const auth = this.injector.get(UserService);
    //       auth.logout();
    //       this.eventsService.errorHappensSource(e.error.error);
    //       break;
    //   }
    //   return Observable.throwError(e);
    // }) as any;
  }
}
